import AiAskBarHomePanel from './AiAskBarHomePanel'

export default function AiAskBarHomePanelBranch({ vm, ...props }) {
  return <AiAskBarHomePanel vm={vm} {...props} />
}
